import React from 'react';
import styles from "../../LocationForm.module.css";
import {ValidationResult} from "../../../../../../elements/validator/component/ValidationComponent";
import {NotEmptyStringValidator} from "../../../../../../elements/validator/Validator";
import {Section} from "../../../../../../elements/section/Section";
import {VehicleDataProvider} from "../../../../../../../api/generated";
import {useAppSelector} from "../../../../../../../app/hooks";
import {AutotraderFields} from "./fields/AutotraderFields";
import {
    LocationFormSelectionProvider,
    LocationRequest,
    LocationRequestPartial,
    WorkingHoursRequest
} from "../../LocationForm";
import {ValidatedSelectField} from "../../../../../../elements/validator/component/ValidatedSelectField";
import {
    allVehicleDataProviderOptions
} from "../../../../../assistant/modal/createAndUpdate/components/util/vehicleDataProviderUtil";
import {FileOnSftpFields} from "./fields/FileOnSftpFields";
import {AutotraderAndFileOnSftpFields} from "./fields/AutotraderAndFileOnSftpFields";
import {SpidersnetFileFields} from "./fields/SpidersnetFileFields";

interface Props<T, W> {
    getMessage: (s: any) => any;
    updateRequest: (update: LocationRequestPartial) => void;
    selectionProvider: LocationFormSelectionProvider<W>;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const VehicleInformation = <
    T extends LocationRequest,
    W extends WorkingHoursRequest
>({
      getMessage,
      updateRequest,
      selectionProvider,
      updateValidationStatus
  }: Props<T, W>) => {

    const vehicleDataProvider = useAppSelector(selectionProvider.vehicleDataProvider)

    const getRequiredFields = () => {
        switch (vehicleDataProvider) {
            case VehicleDataProvider.Autotrader:
            case VehicleDataProvider.TmcAutotrader:
                return <AutotraderFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            case VehicleDataProvider.FileOnSftp:
            case VehicleDataProvider.PipelineStockFile:
                return <FileOnSftpFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            case VehicleDataProvider.SpidersnetFile:
                return <SpidersnetFileFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            case VehicleDataProvider.AutotraderAndFileOnSftp:
                return <AutotraderAndFileOnSftpFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            default:
                return <></>
        }
    }

    return <Section title={"Vehicle Information"}>
        <div className={styles.fieldsLine}>
            <ValidatedSelectField<VehicleDataProvider, T>
                onChange={(v) => updateRequest(
                    {vehicleDataProvider: v}
                )}
                updateValidationStatus={updateValidationStatus}
                fieldName={'vehicleDataProvider'}
                selector={selectionProvider.vehicleDataProvider}
                validator={NotEmptyStringValidator}
                label={'Data Provider'}
                getMessage={getMessage}
                options={allVehicleDataProviderOptions}
            />
        </div>
        {getRequiredFields()}
    </Section>
}
